module.exports = __webpack_public_path__ + "static/ig-b0b1c829b64b31559e37d59df3d9a09e.png";